var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 64 64",
    className: "svg-icon",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36 42.39c1-12.78 14.729-25.29 17.926-29.976 2.778-4.206 1.72-9.203.83-11.4a.78.78 0 0 1 .893-1h-.004c13.89 2.918 14.588 13.48 14.169 18.206-.42 4.726.42 7.913 3.477 7.224C47.71 24.754 46.68 17 46.68 17s14.04 16.676 8.893 33.073c-2.587 8.574-9.032 12.19-14.448 13.89-.28.14-.56-.14-.56-.55.7-2.638 2.508-4.726 3.058-7.644 1.12-4.796-3.327-9.213-6.625-11.71-2.062-1.538-3.385-3.97-3.385-6.712 0-.127.002-.255.008-.381v.018c0-.28-.42-.42-.55-.28a90.106 90.106 0 0 1-6.652 7.202l-.023.022c-5.135 5.696-7.783 12.09-3.197 19.175.14.28-.14.69-.41.56-11.4-3.068-16.117-11.691-15.427-21.273Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxBet);
export default __webpack_public_path__ + "static/media/max-bet.7540b6dd33a4a31c67c5671df3b25224.svg";
export { ForwardRef as ReactComponent };